export const NAME = 'search';